import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RigchecksList from "./pages/rigchecksList/RigchecksList";
import AnswerRigcheck from "./pages/answerRigcheck/AnswerRigcheck";
import AgencyRedirect from "./components/agencyRedirect/AgencyRedirect";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path=":agency">
              <Route
                index
                element={
                  <AgencyRedirect>
                    <RigchecksList />
                  </AgencyRedirect>
                }
              />

              <Route
                path=":checkId"
                element={
                  <AgencyRedirect>
                    <AnswerRigcheck />
                  </AgencyRedirect>
                }
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
